import { v1 as uuidv1 } from 'uuid';
import {
  Box,
  Card,
  CardMedia,
} from '@mui/material';
import TextLines from '../../text/TextLines';
import { getPageStyle } from '../common/LessonPageUtil';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './MatchingThumbnail.scss';

const defaultProps = {
  promptCards: [{}],
  responseCards: [{}, {}, {}, {}, {}],
};

export default function MatchingThumbnail(props) {
  const mergedProps = filterUndefined(props, defaultProps);
  const {
    promptCards,
    responseCards,
  } = mergedProps;
  const getCard = (card, thumbailClass) => (
    <Card className={thumbailClass} style={getPageStyle(card, true)}>
      <Box className='matching-thumbnail-image-container'>
        {
          card.image ? (
            <CardMedia
              className='matching-thumbnail-image'
              image={card.image}
              title='Matching'
            />

          )
            : (
              <Box
                component='div'
                className='matching-thumbnail-placeholder'
              >
                Image
              </Box>
            )
        }
      </Box>
      <Box className='matching-thumbnail-text-container'>
        {card.text
          ? (
            <Box className='matching-thumbnail-with-value'>
              <TextLines textLines={card.text} isThumbnail />
            </Box>
          ) : (
            <Box className='matching-thumbnail-placeholder'>Text</Box>
          )}
      </Box>
    </Card>
  );

  return (
    <Box className='matching-thumbnail-component vizzle-matching-thumbnail'>
      <Box className='matching-thumbnail-prompts-area'>
        {promptCards.map((card) => (
          <Box key={uuidv1()} style={{ width: `${(100 / promptCards.length)}%`, height: '100%' }}>
            {getCard(card, 'matching-thumbnail-prompts-card')}
          </Box>
        ))}
      </Box>
      <Box className='matching-thumbnail-responses-area'>
        {responseCards.map((card) => (
          <Box key={uuidv1()} style={{ width: `${(100 / responseCards.length)}%`, height: '100%' }}>
            {getCard(card, 'matching-thumbnail-responses-card')}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
